import * as requestFromServer from "./patientsCrud";
import { patientsSlice } from "./patientsSlice";
import { spinnerCreate } from "../spinner/spinnerActions";
import moment from "moment";

const { actions } = patientsSlice;

function getCustomerId() {
    return localStorage.getItem("customerId");
}

export const fetchPatientsFilters = (inchargeDate, dischargeDate) => async dispatch => {
    dispatch(spinnerCreate(true));
    let customerId = getCustomerId();
    let params = 'customerId:"' + customerId + '" ';

    var inchargeDateParsed = null;

    if (inchargeDate && inchargeDate.includes('-')) {
        const [from, to] = inchargeDate.split('-').map(s => s.trim());
        const start = moment(from, "DD MMM YY", 'it');
        const end = moment(to, "DD MMM YY", 'it');

        if (start.isValid() && end.isValid()) {
            inchargeDateParsed = [
                start.startOf("day").format("YYYY-MM-DDTHH:mm"),
                end.endOf("day").format("YYYY-MM-DDTHH:mm")
            ];
        }
    }

    var dischargeDateParsed = null;

    if (dischargeDate && dischargeDate.includes('-')) {
        const [from, to] = dischargeDate.split('-').map(s => s.trim());
        const start = moment(from, "DD MMM YY", 'it');
        const end = moment(to, "DD MMM YY", 'it');

        if (start.isValid() && end.isValid()) {
            dischargeDateParsed = [
                start.startOf("day").format("YYYY-MM-DDTHH:mm"),
                end.endOf("day").format("YYYY-MM-DDTHH:mm")
            ];
        }
    }


    if (inchargeDateParsed) {
        params += 'inchargeDateFrom:"' + inchargeDateParsed[0] + '" inchargeDateTo:"' + inchargeDateParsed[1] + '"';
    }

    if (dischargeDateParsed) {
        params += ' dischargeDateFrom:"' + dischargeDateParsed[0] + 'T00:00:00Z" dischargeDateTo:"' + dischargeDateParsed[1] + '"';
    }

    try {
        const response = await requestFromServer
            .findPatientsFilters(params);
        dispatch(actions.patientsFitlersFetched({ entities: response.data }));
        dispatch(spinnerCreate(false));
    }
    catch (error) {
        dispatch(spinnerCreate(false));
        console.error(error);
    }
}

function getPatientsQueryParams(queryParams, isForChart, pagination, sort) {
    const period = queryParams.filter.Period;
    const prescriptions = queryParams.filter.Prescriptions;
    const inchargeDate = queryParams.filter.InchargeDate;
    const dischargeDate = queryParams.filter.DischargeDate;
    const status = queryParams.filter.Status;
    const gender = queryParams.filter.Gender;
    const districts = queryParams.filter.District;
    const searchText = queryParams.filter.SearchText;
    const customerId = getCustomerId();

    const [startRaw, endRaw] = period.split('-').map(s => s.trim());
    const startDate = moment(startRaw, "DD MMM YY", 'it').startOf("day").format("YYYY-MM-DDTHH:mm");
    const endDate = moment(endRaw, "DD MMM YY", 'it').endOf("day").format("YYYY-MM-DDTHH:mm");

    const filters = {};

    if (status.length) {
        filters.status = status;
    }

    if (gender.length) {
        filters.gender = gender;
    }

    if (prescriptions.length) {
        filters.prescriptions = prescriptions;
    }

    if (districts.length) {
        filters.districts = districts;
    }

    if (searchText) {
        filters.searchText = searchText;
    }

    if (inchargeDate && inchargeDate.includes('-')) {
        const [from, to] = inchargeDate.split('-').map(s => s.trim());
        const start = moment(from, "DD MMM YY", 'it');
        const end = moment(to, "DD MMM YY", 'it');

        if (start.isValid() && end.isValid()) {
            filters.inchargeDateRange = [
                start.startOf("day").format("YYYY-MM-DDTHH:mm"),
                end.endOf("day").format("YYYY-MM-DDTHH:mm")
            ];
        }
    }

    if (dischargeDate && dischargeDate.includes('-')) {
        const [from, to] = dischargeDate.split('-').map(s => s.trim());
        const start = moment(from, "DD MMM YY", 'it');
        const end = moment(to, "DD MMM YY", 'it');

        if (start.isValid() && end.isValid()) {
            filters.dischargeDateRange = [
                start.startOf("day").format("YYYY-MM-DDTHH:mm"),
                end.endOf("day").format("YYYY-MM-DDTHH:mm")
            ];
        }
    }

    const result = {
        customerId,
        startDate,
        endDate,
        filters
    };

    if (!isForChart) {
        result.pagination = {
            first: pagination?.Row || 50,
            ...(pagination?.EndCursor && { after: pagination.EndCursor })
        };

        if (sort) {
            const sortMap = {
                Id: ["id"],
                Nominative: ["lastName", "firstName"],
                Gender: ["gender"],
                District: ["districtName"],
                Status: ["patientState"],
                Prescriptions: ["prescriptionDetailDescription"],
                Provision: ["provisionsCount"],
                InchargeDate: ["prescriptionDetailStartDate"],
                DischargeDate: ["prescriptionDetailEndDate"],
                TherapyDays: ["therapyDays"]
            };

            const fields = sortMap[sort.dataField];

            if (fields) {
                result.sort = {
                    fields,
                    order: sort.order?.toUpperCase() || "ASC"
                };
            }
        }
    }

    return result;
}

export const fetchPatients = (queryParams, pagination, sort, isChangedSort) => async dispatch => {
    dispatch(spinnerCreate(true));

    let params = getPatientsQueryParams(queryParams, false, pagination, sort, isChangedSort);

    try {
        const response = await requestFromServer.findPatients(params);

        dispatch(
            actions.patientsFetched({
                entities: {
                    data: {
                        patientsReview: response.data
                    }
                },
                holdPagination: pagination,
                isChangedSort: isChangedSort
            })
        );
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(spinnerCreate(false));
    }
};

export const fetchPatientsForFile = (queryParams, sort, callback) => async dispatch => {
    dispatch(spinnerCreate(true));

    let params = getPatientsQueryParams(queryParams, true, null, sort);

    try {
        const response = await requestFromServer.findPatients(params);

        dispatch(
            actions.patientsForFileFetched({
                entities: {
                    data: {
                        patientsReview: response.data
                    }
                },
                callback
            })
        );
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(spinnerCreate(false));
    }
};

export const fetchPatientsChart = queryParams => async dispatch => {
    dispatch(spinnerCreate(true));

    const params = getPatientsQueryParams(queryParams, true);

    try {
        const response = await requestFromServer.findPatientsChart(params);

        // Wrap in shape expected from GraphQL
        dispatch(
            actions.patientsChartFetched({
                entities: {
                    data: {
                        patientsReviewDaysGraphV2: response.data
                    }
                }
            })
        );
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(spinnerCreate(false));
    }
};

export const fetchPatient = id => async dispatch => {
    if (!id) {
        return dispatch(actions.patientFetched({ patientById: undefined }));
    }
    dispatch(spinnerCreate(true));
    try {
        let historyLimitDate = moment().subtract(1, "year").format("YYYY-MM-DD") + "T00:00:00Z";

        const response = await requestFromServer.getPatientById(id, historyLimitDate);
        try {
            dispatch(actions.patientFetched({ patientById: response.data }));
            dispatch(spinnerCreate(false));
        } catch (err) {
            dispatch(actions.patientFetched({ patientById: response.data }));
            dispatch(spinnerCreate(false));
        }
    }
    catch (error) {
        console.error(error);
        dispatch(spinnerCreate(false));
    }
};

export const fetchPatientChart = (id, queryParams) => async dispatch => {
    if (!id) {
        return dispatch(actions.patientFetched({ patientChart: undefined }));
    }
    dispatch(spinnerCreate(true));

    let params = 'patientId:"' + id + '" startDate:"' + queryParams + '"';

    try {
        const response = await requestFromServer.findPatientChart(params)
        dispatch(actions.patientChartFetched({ patientChart: response.data }));
        dispatch(spinnerCreate(false));
    } catch (error) {
        console.error(error);
        dispatch(spinnerCreate(false));
    }
};

export const fetchPatientLoxChart = (id, queryParams) => async dispatch => {
    if (!id) {
        return dispatch(actions.patientFetched({ patientChart: undefined }));
    }

    dispatch(spinnerCreate(true));

    let params = 'patientId:"' + id + '" startDate:"' + queryParams + '"';

    try {
        const response = await requestFromServer.findPatientLoxChart(params)
        dispatch(actions.patientLoxChartFetched({ patientLoxChart: response.data }));
        dispatch(spinnerCreate(false));
    } catch (error) {
        console.error(error);
        dispatch(spinnerCreate(false));
    }
};

/*export const fetchPatientInvoices = id => async dispatch => {
    if (!id) {
        return dispatch(actions.patientFetched({ patientInvoices: [] }));
    }
    dispatch(spinnerCreate(true));
    try {
        const response = await requestFromServer.getPatientInvoices(id);
        dispatch(actions.patientInvoicesFetched({ patientInvoices: response.data }));
        dispatch(spinnerCreate(false));
    } catch (error) {
        console.error(error);
        dispatch(spinnerCreate(false));
    }
}*/

export const fetchPatientProvisionsNear = id => async dispatch => {
    if (!id) {
        return dispatch(actions.patientFetched({ patientProvisionsNear: undefined }));
    }
    dispatch(spinnerCreate(true));
    try {
        const response = await requestFromServer.findPatientProvisionsNear(id);
        dispatch(actions.patientProvisionsNearFetched({ patientProvisionsNear: response.data }));
        dispatch(spinnerCreate(false));
    } catch (error) {
        console.error(error);
        dispatch(spinnerCreate(false));
    }
}

export const setInvoiceRow = invoice => dispatch => {
    dispatch(actions.setInvoiceRow({ data: invoice }));
}

export const openedPrescriptionAccordion = (openedAccordion) => dispatch => {
    setTimeout(() => {
        dispatch(actions.setOpenedPrescriptionAccordion({ data: openedAccordion }));
    }, 350);
}

export const setPrescriptionRow = prescription => dispatch => {
    dispatch(actions.setPrescriptionRow({ data: prescription }));
}
